/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Filter_Max_CostInputs */

const en_filter_max_cost = /** @type {(inputs: Filter_Max_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≤ ${i?.cost}`)
};

const de_filter_max_cost = /** @type {(inputs: Filter_Max_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≤ ${i?.cost}`)
};

/**
* | output |
* | --- |
* | "≤ {cost}" |
*
* @param {Filter_Max_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_max_cost = /** @type {((inputs: Filter_Max_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Max_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_max_cost(inputs)
	return en_filter_max_cost(inputs)
});